import Vue from 'vue'
import BaseCard from '@/components/base/Card'
import BaseSubheading from '@/components/base/Subheading'

Vue.component(BaseCard.name, BaseCard)
Vue.component(BaseSubheading.name, BaseSubheading)
